// @ts-check

import { createDataGridContext } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.context';
import { useContext } from "react";

export const [FeedDataGridContext, FeedDataGridContextProvider] = createDataGridContext('feed');

export function useFeedDataGridContext() {
    return useContext(FeedDataGridContext);
}
